import { useQuery } from 'react-query';
import { CACHE_1_HOUR_MS } from '../../../config/utils/cacheUtils';
import { PosTerminal } from '../../../services/viva/interfaces/viva.interface';
import { apiRQ } from '../../api';

const getAvailablePosViva = async () => {
  const resp = await apiRQ.get<PosTerminal[]>('/viva/devices');
  return resp.data;
};

export const useAvailableVivaPos = (enabled: boolean, companyId: string | undefined) => {
  return useQuery<PosTerminal[], Error>(['useAvailableVivaPos', companyId], getAvailablePosViva, {
    enabled: enabled && !!companyId,
    cacheTime: CACHE_1_HOUR_MS,
    staleTime: CACHE_1_HOUR_MS,
    refetchOnWindowFocus: false,
    retry: 3,
  });
};
